import * as React from 'react';

import { logErrorAndAddToRum } from '@/imports/logging/ClientLogger';

import { PostFeedError } from './components/PostFeedError';

export class PostFeedErrorBoundary extends React.Component<
  {},
  { hasPostFeedError: boolean }
> {
  constructor(props: {}) {
    super(props);
    this.state = { hasPostFeedError: false };
  }

  static getDerivedStateFromError(): any {
    // Update state so the next render will show the fallback UI.
    return { hasPostFeedError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    logErrorAndAddToRum(error, { errorInfo });
  }

  render(): React.ReactNode {
    return this.state.hasPostFeedError ? (
      <PostFeedError />
    ) : (
      this.props.children
    );
  }
}
